import { FC, ReactNode } from 'react'

import styled from 'styled-components'
import { Modal } from 'antd'

import { MAX_MOBILE_WIDTH, variables } from 'src/Styled/variables'
import { closeButtonStyles } from 'src/Components/Buttons/CloseButton'

const StyledModal = styled(Modal)`
  max-width: 600px;
  width: 100% !important;

  .ant-modal-body {
    width: 100% !important;
    display: flex;
    flex-direction: column;
    gap: 24px;
    position: relative !important;
    padding-top: 51px;
    max-height: calc(100vh - 70px);
    overflow-y: auto;
  }

  .ant-modal-content {
    width: 100% !important;
    padding: 0;
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.color.lightGrey};
    background-color: ${({ theme }) => theme.color.white};
    box-shadow: ${({ theme }) => theme.shadow.header};
  }

  .ant-modal-close {
    ${closeButtonStyles}

    top: 8px;
    inset-inline-end: 8px;

    .ant-modal-close-x {
      display: flex;
      align-items: center;
      justify-content: center;
      color: inherit;
    }
  }

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    border-radius: 16px;
  }

  @keyframes fadeInModal {
    0% {
      opacity: 0;
      transform: translate(-50%, 0%) scale(0.8);
      visibility: hidden;
    }
    1% {
      visibility: visible;
    }
    100% {
      opacity: 1;
      transform: translate(-50%, 0%) scale(1);
      visibility: visible;
    }
  }
`

export const Title = styled.div`
  font-family: 'Segoe UI';
  font-weight: ${variables.fontWeight600};
  font-size: ${variables.fontSize18};
  font-style: normal;
  width: 100%;
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
`

const TitleWrapper = styled.div`
  height: 54px;
  position: absolute;
  top: 0px;
  padding-left: 24px;
  padding-top: 16px;
  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    z-index: 4;
    background-color: ${({ theme }) => theme.color.white};
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }
`

const HeaderBorder = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.color.lightGrey};
  position: absolute;
  top: 54px;
  left: 0;
`

export interface PrimaryInfoModalProps {
  children: ReactNode
  onClose: () => void
  isOpen: boolean
  title: string
  className?: string
  closable?: boolean
  maskClosable?: boolean
  keyboard?: boolean
}

export const PrimaryInfoModal: FC<PrimaryInfoModalProps> = ({
  children,
  onClose,
  isOpen,
  title,
  className,
  closable,
  maskClosable,
  keyboard,
}) => (
  <StyledModal
    open={isOpen}
    footer={null}
    centered
    destroyOnClose
    onCancel={onClose}
    closable={closable}
    maskClosable={maskClosable}
    keyboard={keyboard}
    className={className}
  >
    <HeaderBorder />
    <TitleWrapper>
      <Title>{title}</Title>
    </TitleWrapper>
    {children}
  </StyledModal>
)
